import { render } from "./Appraisal.vue?vue&type=template&id=c1192d8a&scoped=true"
import script from "./Appraisal.vue?vue&type=script&lang=js"
export * from "./Appraisal.vue?vue&type=script&lang=js"

import "./Appraisal.vue?vue&type=style&index=0&id=c1192d8a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1192d8a"]])

export default __exports__